import { render, staticRenderFns } from "./AuthAside.vue?vue&type=template&id=3ac079e9&scoped=true&"
import script from "./AuthAside.vue?vue&type=script&lang=js&"
export * from "./AuthAside.vue?vue&type=script&lang=js&"
import style0 from "./AuthAside.vue?vue&type=style&index=0&id=3ac079e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac079e9",
  null
  
)

export default component.exports